// from application.js
export default (window as any).MoreInfo;
